import React, {useState, useEffect} from "react";
import {Top, Button, Faq} from "parts";
import {
  Plan,
  TimerPanel,
  Paysafe,
  Guarantee,
  PaymentWindow,
  FooterPaywall, Stores, StylesPrice, Payment
} from "parts/paywall";
import {
  isIos,
  setStep,
  usePaywall, useScrollDepthPaywall, useSurvey
} from "utils";
import {Trans, useTranslation} from "react-i18next";
import {ReactComponent as Star} from 'assets/img/icon/star3.svg'
import {Goals} from "../parts";

export function Paywall({step, toAdd, nextUrl}) {
  const
    {t} = useTranslation('common', {keyPrefix: 'paywall'}),
    {t: t0} = useTranslation(),
    {t: t1} = useTranslation('common', {keyPrefix: 'payment'})

  const [active, setActive] = useState()

  usePaywall({active})
  useScrollDepthPaywall('paywall')

  const
    {goal} = useSurvey(),
    goalTitle = goal?.short || goal?.title,

    [payment, setPayment] = useState(false),
    [pricePaywall, setPricePaywall] = useState(),
    [timing] = useState(15 * 60),

    isApplePay = isIos(),

    [paymentType, setPaymentType] = useState()

  useEffect(() => {
    setStep({...step}, toAdd)
  }, [])

  const
    getPeriod = (field, first) => {
      const periods = t1('periods', {returnObjects: true})

      return periods[active?.period]?.[first] || periods[active?.period]?.[field] || active?.period
    },
    handlePay = (type, e) => {
      if (e)
        e.preventDefault()

      setPaymentType(type)
      setPayment(true)
    },
    // FIXME: dupe
    handleItemContent = item => {
      const
        isBest = item.period === '3month'

      return (
        <>
          {
            isBest &&
            <div className={'promo-outer row center gap-0'}>
              <Star className={'me-1'}/>
              Best Value
            </div>
          }
          <div className={'w-100 text-start stack gap-1'} style={{alignItems: 'start'}}>
            <strong style={{textTransform: 'capitalize', lineHeight: 1.25}}>
              {t0(`payment.periods.${item.period}.value`).replace('1-year', '12-Months')}
              {' Plan'}
            </strong>
            <p className={'note small-sm fw-400'}>
              {
                (
                  (item.standardPrice || item.price)
                ) &&
                <s className={'me-2'} style={{textDecoration: 'line-through', textDecorationColor: '#DD4B4E'}}>
                  {item.currency} {item.standardPrice || item.price}
                </s>
              }
              <em style={{color: '#fff'}}>{item.currency} {item.fullPrice}</em>&nbsp;
            </p>
          </div>

          <div className={'nowrap'}>
            <sup>{item.currencySymbol}</sup>
            <big>{Math.trunc(item.dayPrice)}</big>
            <div style={{alignItems: 'start'}}>
              <Trans i18nKey="plan.perDay" t={t}>
                <em>{{dayPrice: Math.round(item.dayPrice % 1 * 100)}}</em>
                <small>PER DAY</small>
              </Trans>
            </div>
          </div>
          {
            isBest &&
            <div className={'w-100 surface small fw-400'} style={{backgroundColor: 'rgba(8, 9, 13, 0.36)'}}>
              <p style={{marginBottom: 8}}>
                <Star className={'me-1'} style={{color: '#3ED06A'}}/> Best choice for
                <span className={'tag ml-2'}
                      style={{
                        backgroundColor: 'rgba(62, 208, 106, 0.12)',
                        color: '#3ED06A',
                        borderRadius: 4,
                        padding: '4px 8px'
                      }}
                >
                <img className={'me-1'} width={10} height={10} alt={'Goal'} src={'/static/img/icon/goal.svg'}/>
                  {goalTitle}
              </span>
              </p>
              <p>
                <b className={'me-1'} style={{color: '#F6C558'}}>%</b>{' '}
                {
                  item.period === '1year'
                    ? 'Pay for 6 months, Get 12!'
                    : 'Pay for 6 weeks, Get 12!'
                }
              </p>
            </div>
          }
        </>
      )
    }

  const
    getPlan = (props) =>
      <>
        <h1 className={'w-100 text-center'}>{t('getMyPlan.h1')}</h1>

        <Plan actived={active} strict={true}
              onChange={item => setActive(item)}
              itemContent={handleItemContent} {...props}
        >
          <Paysafe>100% Secure • Cancel Anytime</Paysafe>
          {
            isApplePay
              ?
              <>
                {/*<Button variant={'white'} onClick={() => handlePay('applePay')}
                        style={{
                          fontSize: 20,
                          fontWeight: 500,
                          fontFamily: 'SF Pro Text, -apple-system, sans-serif'
                        }}
                >
                  <Trans i18nKey="getMyPlan.btnApplePay" t={t}>
                    Continue with <span style={{fontSize: 23, fontWeight: 600, margin: '0 5px'}}>Pay</span>
                  </Trans>
                </Button>*/}

                <Payment one={true} data={active} nextUrl={nextUrl} paymentType={'applePay'}/>

                <p>
                  <a href="#pay" className={'notice small'} style={{textDecoration: 'underline'}}
                     onClick={(e) => handlePay('credit', e)}>{t('getMyPlan.btnOthers')}</a>
                </p>
              </>
              : <Button onClick={() => setPayment(true)} style={{textTransform: 'capitalize'}}>{t('getMyPlan.btn')}</Button>
          }
          <p className={'note md fw-400 text-start'}>
            {t1('subscription', {
              period: getPeriod('value'),
              dialect: getPeriod('dialect'),
              currency: active?.currency,
              price: active?.price
            })}
          </p>
        </Plan>
      </>

  return (
    <>
      <StylesPrice/>

      <TimerPanel count={timing}/>

      <div className={'wrap'}>
        <Top className={'gap-3 pb-0'}>
          <div className={'block items secondary'}>
            <Goals/>
            <hr/>

            {getPlan({
              onChangeResponse: (r) => {
                setPricePaywall(r)
                return r
              },
            })}
          </div>

          <Guarantee/>

          <div className={'block items'}>
            <h3 className={'h1'}>{t('info.love')}</h3>
            <div className={'w-100 cards gap-3'}>
              {t('info.loveCards', {returnObjects: true}).map(({name, note}, i) =>
                <div key={name} className={'surface p-0 pre-line rounded-2 items gap-2 center text-center'}>
                  <h4 className={'pb-0'} style={{padding: 8}}>{name}</h4>

                  <div className={'surface px-2 py-1 small-sm tg row w-auto gap-2'} style={{backgroundColor: '#333A49', lineHeight: 1}}>
                    <img width={10} height={10} src={'/static/img/icon/star.svg'} loading={'lazy'} alt="★"/>
                    {note}
                  </div>

                  <img width={157} height={122} alt={''} className={'mt-auto w-100 mw-100'}
                       style={{borderRadius: '0 0 8px 8px'}}
                       src={`/charisma/static/img/paywall/love/${i}.png`} loading={'lazy'}/>
                </div>
              )}
            </div>
          </div>

          <Stores/>

          <img className={'w-100 mw-100'} width={350} height={468} alt={goalTitle}
               src={`/${process.env.REACT_APP_MODULE}/static/img/paywall/journal.png`} loading={'lazy'}
          />
          <p className={'w-100 text-center'}>
            <a rel="noreferrer" target={'_blank'} className={'notice-2 small-sm'}
               href={'https://time.com/collection/worlds-top-edtech-companies-2025/'}>{t('info.journal')}</a>
          </p>

          <Faq/>

          {
            pricePaywall &&
            <div className={'block items secondary'}>
              {getPlan({
                price: pricePaywall
              })}
            </div>
          }

          <Guarantee/>
        </Top>

        <FooterPaywall/>
      </div>

      {
        payment &&
        <PaymentWindow data={active} nextUrl={nextUrl} paymentType={paymentType} payInfo={false}
                       onClose={() => setPayment(false)}>
          <Paysafe>{t1('checkout')}</Paysafe>
          <img width={326} height={30} src={'/static/img/paywall/logos-2.png'} loading={'lazy'} alt={t1('checkout')}/>

          <p className={'note md fw-400'}>
            {t1('subscription', {
              period: getPeriod('value'),
              dialect: getPeriod('dialect'),
              currency: active?.currency,
              price: active?.price
            })}
          </p>
        </PaymentWindow>
      }
    </>
  )
}